import React from 'react'
import classNames from 'classnames'
import styles from './Scenario.module.scss'
import { IStoredRun } from '../../../../store/state'
import { Checkbox } from '@material-ui/core'
import { inputs } from '../../../../models/complex-model/inputs'
import IconLink from '@material-ui/icons/Link'
import IconClose from '@material-ui/icons/Close'
import IconLock from '@material-ui/icons/Lock'
import IconInfo from '@material-ui/icons/Info'
import { simulationService } from '../../../../services/SimulationService'
import { Modal } from '../../../../base/components/ui/Modal'

interface Props {
  storedRun: IStoredRun,
  index: number
}

export const ControlScenario = ({ storedRun, index }: Props) => {
  const [show, setShow] = React.useState(false)
  const url = `${document.location.origin}/simulation#${JSON.stringify(storedRun.values)}`
  const [showScenarioModal, setShowScenarioModal] = React.useState(false)
  const [scenarioModalTitle, setScenarioModalTitle] = React.useState('')
  const [scenarioModalContent, setScenarioModalContent] = React.useState()

  const onCopy = React.useCallback(() => {
    navigator.clipboard.writeText(url).catch(window.logger.error)
    setShow(false)
  }, [url])

  const openScenarioModal = () => {
    setScenarioModalTitle(storedRun.name)
    setShowScenarioModal(true)
    setScenarioModalContent(
      () => (
        inputs.map(input => (
            <div className={styles.root}>
              <div className={styles.list}>
                <div className={styles.listLabel}>{input.label}:</div>
                <div className={styles.listValue}>{storedRun.values[input.var]}</div>
              </div>
            </div>
          )
        )
      )
    )
  }

  return (
    <div className={styles.root}>
      <Checkbox
        className={styles.checkbox}
        style={{ color: storedRun.color, }}
        checked={storedRun.isActive}
        onChange={() => simulationService.toggleStoredRun(storedRun)}
      />
      <input
        className={classNames(styles.runInput, { [styles.readOnly]: storedRun.isDefaultScenario })}
        value={storedRun.name}
        readOnly={storedRun.isDefaultScenario}
        onClick={() => simulationService.applyRunToCurrentInputs(storedRun)}
        onChange={e => simulationService.setRunName(storedRun.key, e.target.value)}
      />
      <div className={styles.copy} onClick={() => setShow(true)}>
        <IconLink />
      </div>
      <div className={styles.info} onClick={() => openScenarioModal()}>
        <IconInfo />
      </div>

      {
        storedRun.isDefaultScenario
          ?
        <div className={styles.lock}><IconLock fontSize={'small'} /></div>
          :
          <div className={styles.remove} onClick={() => simulationService.removeStoredRun(index)}>
            <IconClose fontSize={'small'} />
          </div>
      }

      <Modal
        open={show}
        title={'Scenario Link'}
        content={url}
        actionLabel={'Copy'}
        close={() => setShow(false)}
        onAction={onCopy}
      />

      <Modal
        open={showScenarioModal}
        title={scenarioModalTitle}
        content={scenarioModalContent}
        actionLabel={'close'}
        close={() => setShowScenarioModal(false)}
        onAction={() => setShowScenarioModal(false)}
      />
    </div>
  )
}
